const GEO_CACHE_KEY = "user_geo_country";

export const getUserCountryFromIP = async () => {
  // Check cache first
  const cached = localStorage.getItem(GEO_CACHE_KEY);
  if (cached) return cached;

  try {
    const ip = localStorage.getItem("ip");
    const url = ip
      ? `https://ipapi.co/${ip}/json/`
      : "https://ipapi.co/json/";
    const response = await fetch(url);
    const data = await response.json();
    const countryCode = data.country_code || "IN";
    localStorage.setItem(GEO_CACHE_KEY, countryCode);
    return countryCode;
  } catch (error) {
    console.error("Geolocation lookup failed:", error);
    return "IN"; // Default to India on failure
  }
};

export const getCurrencyFromCountry = (countryCode) => {
  return countryCode === "IN" ? "INR" : "USD";
};

export const isIndianUser = (countryCode) => {
  return countryCode === "IN";
};
